import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetAllStoreDetails } from "../../api";
import "../../styles/viewCustomer.css";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { showInfoToast } from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Stores = () => {
  const navigate = useNavigate();
  const [AllStores, setAllStores] = useState([]);
  const [Store_id, setStore_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);
  const { userPermID } = useStateContext();

  const handleRowSelected = (args) => setStore_id(args.data.store_id);

  const customersGrid = [
    {
      field: "name",
      headerText: "Store",
      minWidth: "120",
      width: "160",
      maxWidth: "320",
      textAlign: "Left",
    },
    {
      field: "email",
      headerText: "Email",
      minWidth: "120",
      width: "140",
      maxWidth: "240",
      textAlign: "Left",
    },
    {
      field: "contact",
      headerText: "Contact",
      minWidth: "130",
      width: "140",
      maxWidth: "240",
      textAlign: "Center",
    },
    {
      field: "tax",
      headerText: "Tax",
      minWidth: "120",
      width: "120",
      maxWidth: "160",
      textAlign: "Right",
    },
    {
      field: "street_address",
      headerText: "Street Address",
      minWidth: "180",
      width: "220",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "city",
      headerText: "City",
      minWidth: "120",
      width: "140",
      maxWidth: "240",
      textAlign: "left",
    },
  ];

  const handleAddStoreClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    navigate("/Stores/Add");
  };

  const handleEditStoreClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Store_id !== "") navigate(`/Stores/Edit/${Store_id}`);
    else showInfoToast("Info!", "Please select store to edit.");
  };

  const handleViewStoreClick = async () => {
    if (Store_id !== "") navigate(`/Stores/ViewStore/${Store_id}`);
    else showInfoToast("Info!", "Please select store to view.");
  };

  const handleRefresh = async () => {
    const resp = await GetAllStoreDetails();
    setAllStores(resp.data || []);
  };

  useEffect(() => {
    setloading(true);
    trackPromise(
      GetAllStoreDetails()
        .then((resp) => setAllStores(resp.data))
        .catch((error) => console.error("Error fetching data:", error))
        .finally(() => setloading(false)),
    );
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Stock" title="STORES" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(45) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddStoreClick} />
            </Col>
          )}
          {userPermID.includes(46) && (
            <Col md="auto p-0">
              <Button text="Update" onClick={handleEditStoreClick} />
            </Col>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllStores}
        cols={customersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(44) && handleViewStoreClick}
        persistant={false}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Stores;
